import { UpdateCustomEventSettingsRequestPayload } from 'modules/customEvents/types';
import { ApiMethod, get, post } from 'services/api';
import {
  RestQueryHookResult,
  UseRestQueryOptions,
  useRestMutation,
  UseRestMutationOptions,
  useRestQuery,
} from 'utils/hooks/api';

export const DELETION_POLICIES_URL = '/deletionPolicies/getForProject';
export const UPDATE_DELETION_POLICIES_URL = '/deletionPolicies/updateRetention';
export const CUSTOM_EVENTS_COUNT_URL = '/deletionPolicies/customEventCount';

export const updateCustomEventSettingsUrl = (projectId: number) =>
  `/project/${projectId}/customEventSettings`;

export const getDeletionPoliciesByProject = () => get(DELETION_POLICIES_URL);

export const updateDeletionPolicies = (deletionPolicyParams: any) =>
  post(UPDATE_DELETION_POLICIES_URL, deletionPolicyParams);

export const updateCustomEventSettings = (payload: UpdateCustomEventSettingsRequestPayload) => {
  const url = updateCustomEventSettingsUrl(payload.projectId);
  return post(url, payload);
};

export const useUpdateCustomEventSettings = (projectId: number, options?: UseRestMutationOptions) =>
  useRestMutation(updateCustomEventSettingsUrl(projectId), ApiMethod.post, options);

export const useGetCustomEventsCount = (
  params: {
    includeNames?: string;
    excludeNames?: string;
    ageInDays: number;
  },
  options: UseRestQueryOptions,
): RestQueryHookResult => useRestQuery(CUSTOM_EVENTS_COUNT_URL, params, options);
